import styled from 'styled-components';
import { screenMd } from 'constants/styles/breakpoints';
import bubblesImg from 'assets/images/bubles.png';
import backgroundReportsBanner from 'assets/images/background_reports_banner.png';

const ReportsTopBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-height: 92px;
  border-radius: 10px;
  padding: 14px 16px 14px 20px;
  color: #ffffff;
  margin: 10px 0 18px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  /* Top layer: bubbles aligned right; Bottom layer: full banner image */
  background-image: url(${bubblesImg}), url(${backgroundReportsBanner});
  background-size: auto 100%, cover;
  background-repeat: no-repeat, no-repeat;
  background-position: right center, center;

  ${screenMd} {
    padding: 18px 20px;
    margin: 0 0 20px;
  }

  .copy {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }

  .icon-pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 999px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.28) 0%,
      rgba(255, 255, 255, 0.12) 100%
    );
    flex: 0 0 auto;
    position: relative;
  }

  .icon-inner {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.3);
  }

  .title {
    color: var(--white);
    font-family: var(--font-family-base);
    font-size: 20px;
    font-style: normal;
    font-weight: 900;
    line-height: 26px; /* 130% */
    margin: 0;
  }
  .subtitle {
    color: var(--white);
    font-family: var(--font-family-base);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    margin: 2px 0 0;
  }
`;

export default ReportsTopBar;
